module.exports = __webpack_public_path__ + "img/icon_laoren.645ff697.png";